import {
  ORDER_ITEMS_BATCH_DELETE_REQUEST,
  ORDER_ITEMS_BATCH_DELETE_SUCCESS,
  ORDER_ITEMS_BATCH_DELETE_FAILURE,
  ORDER_ITEMS_FETCH_MANY_REQUEST,
  ORDER_ITEMS_FETCH_MANY_SUCCESS,
  ORDER_ITEMS_FETCH_MANY_FAILURE,
  ORDER_ITEMS_FETCH_REQUEST,
  ORDER_ITEMS_FETCH_SUCCESS,
  ORDER_ITEMS_FETCH_FAILURE,
  ORDER_ITEMS_SAVE_REQUEST,
  ORDER_ITEMS_SAVE_SUCCESS,
  ORDER_ITEMS_SAVE_FAILURE,

  EMPTY_ORDER_ITEMS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(ORDER_ITEMS_BATCH_DELETE_REQUEST)
    return window.axios.post('/orders', { _method: 'DELETE', ids }).then(response => {
      commit(ORDER_ITEMS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(ORDER_ITEMS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(ORDER_ITEMS_FETCH_MANY_REQUEST)
    return window.axios.get('/orders', { params: { query, page, ...extraParams } }).then(response => {
      commit(ORDER_ITEMS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(ORDER_ITEMS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(ORDER_ITEMS_FETCH_REQUEST)
    return window.axios.get(`/orders/${id}`).then(response => {
      commit(ORDER_ITEMS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(ORDER_ITEMS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/orders/${user.id}` : '/orders'
    const method = user.id ? 'put' : 'post'

    commit(ORDER_ITEMS_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(ORDER_ITEMS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(ORDER_ITEMS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(ORDER_ITEMS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_ORDER_ITEMS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
